// Compact 2-state language toggle for the app header.
//
// Design: segmented pill (中/EN), current state highlighted. Click toggles.
// Why segmented (not dropdown): only 2 options — a dropdown wastes a click and
// hides the alternative. Pill makes the alternative one tap away and visible.

import { SUPPORTED_LOCALES } from '@examforge/shared/i18n';
import { useLocale } from './use-t.js';

const LABELS: Record<string, string> = {
  zh: '中',
  en: 'EN',
};

const ARIA: Record<string, string> = {
  zh: '切换到中文',
  en: 'Switch to English',
};

export function LanguageToggle() {
  const { locale, setLocale } = useLocale();

  return (
    <div className="lang-toggle" role="group" aria-label="Interface language">
      {SUPPORTED_LOCALES.map((loc) => (
        <button
          key={loc}
          type="button"
          className={`lang-toggle-btn${loc === locale ? ' is-active' : ''}`}
          aria-pressed={loc === locale}
          aria-label={ARIA[loc]}
          onClick={() => setLocale(loc)}
        >
          {LABELS[loc]}
        </button>
      ))}
    </div>
  );
}
